import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { getTotal } from "../helpers/categories"

const IndustryFilters = (props) => (
  <StaticQuery
    query={graphql`
      {
        allSanityIndustryCategory {
          edges {
            node {
              slug { current }
              title
              _id
            }
          }
        }
        allSanityCaseStudy {
          group(field: category___slug___current) {
            totalCount
            fieldValue
          }
        }
      }
    `}
    render={data => {
      const cats = data.allSanityIndustryCategory.edges
      const totals = data.allSanityCaseStudy.group

      return (
        <ul data-theme="brandDelta" id="categories-list">
          <li>
            <Link to={`/case-studies/`}>
              All
            </Link>
          </li>
          {cats.map(({node: cat}) =>
            getTotal(cat.slug.current, totals) > 0 ? (
              <li key={cat._id}>
                <Link to={`/case-studies/${cat.slug.current}/`}>
                  {cat.title} ({getTotal(cat.slug.current, totals)})
                </Link>
              </li>
            ) : null
          )}
        </ul>
      )
    }}
  />
)

export default IndustryFilters
